module.exports = __webpack_public_path__ + "img/forgot-password.38c4910b.svg";